import * as React from "react";
import { forwardRef } from "react";
const PlaySVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M5 19.29V4.71a1 1 0 0 1 1.49-.872l12.96 7.29a1 1 0 0 1 0 1.744l-12.96 7.29A1 1 0 0 1 5 19.29" }));
const ForwardRef = forwardRef(PlaySVG);
export default ForwardRef;
//# sourceMappingURL=Play.js.map